<template>
    <div class="strava_connectivity">
        <div v-if="strava_information.strava_auto_disconnected_at" class="kgk-strava-auto-disconnect-notice">
            <p>
                Deine Strava-Verbindung wurde wegen längerer Inaktivität automatisch getrennt.
                Du kannst sie jederzeit erneut verbinden.
            </p>
            <button type="button" @click.prevent="dismissAutoDisconnectNotice">
                Verstanden
            </button>
        </div>

        <div v-if="strava_information.stravaConnected == 0 && strava_information.strava_enabled == 1" class="kgk-connect-strava-btn">
            <a :href="strava_information.loginWithStravaLink">
                <img :src="require('@/assets/strava/connectwith/btn_strava_connectwith_orange/btn_strava_connectwith_orange.png')" alt="Connect with Strava">
            </a>
        </div>

        <div v-else-if="strava_information.stravaConnected == 1 && strava_information.strava_enabled == 1" class="kgk-disconnect-strava-btn">
            <button type="button" @click.prevent="disconnectStrava">
                <i class="fas fa-ban"></i>
                <span class="button-text">Disconnect Strava</span>
            </button>
        </div>
    </div>
  </template>
  
  <script>
  import user from '../../api/user.js';

  export default {
    data() {
        return {
            strava_information: {},
            stravaQueryParameters: {},
            loading: false,
        }
    },
    methods: {
      disconnectStrava() {
        // Hier kannst du den Code für die Verbindung mit Strava einfügen
        console.log('Disconnecting from Strava...');

        this.loading = true;

        user.stravaDeauthorize(
            this,
            data => {
                this.strava_information = data;
                this.$router.push('/profile');
                this.$router.go(0);
                this.$nextTick(() => {
                    this.$notify({
                        type: 'success',
                        title: 'Verbindung mit Strava getrennt.',
                        text: `Schade.`
                    });
                });
            },
            () => this.error = 'Leider konnte die Verbindung von Strava nicht getrennt werden.',
            () => this.loading = false
        );

      },
      dismissAutoDisconnectNotice() {
        user.stravaAcknowledgeAutoDisconnect(
            this,
            () => {
                this.strava_information.strava_auto_disconnected_at = null;
            },
            () => this.error = 'Es ist ein Fehler aufgetreten',
            () => {},
        );
      },
      getStravaInformation() {
        this.loading = true;

        user.stravaAuthorize(
            this,
            data => {
                this.strava_information = data;
            },
            () => this.error = 'Es ist ein Fehler aufgetreten',
            () => this.loading = false,
            ''
        );
      },
      activateStrava(){
        this.loading = true;

        let parameters = "";

        for(const key in this.stravaQueryParameters)
        {
            if(this.stravaQueryParameters.hasOwnProperty(key)) {
                if(parameters.length == 0){
                    parameters += "?"+key+"="+this.stravaQueryParameters[key];
                }else{
                    parameters += "&"+key+"="+this.stravaQueryParameters[key];
                }
            }
        }

        user.stravaAuthorize(
            this,
            data => {
                this.strava_information = data;
                
                this.$router.push('/profile');
                this.$router.go(0);
                this.$nextTick(() => {
                    this.$notify({
                        type: 'success',
                        title: 'Verbindung mit Strava hergestellt.',
                        text: `Du kannst jetzt deine Läufe unter "Läufe" direkt von Strava importieren.`
                    });
                });
                //this.$emit('forceRefresh');
            },
            () => this.error = 'Es ist ein Fehler aufgetreten',
            () => this.loading = false,
            parameters
        );
      }
    },
    mounted() {
        if(this.$route.params.jumpto == 'strava')
        {
            this.isStravaActivation = true;
            this.loading = true;
            this.stravaQueryParameters = this.$route.query;
            this.activateStrava();
        }else{
            this.getStravaInformation();
        }
    }
  }
  </script>
  
  <style scoped>
  /* Hier kannst du dein CSS für das ConnectStrava-Template hinzufügen */
  /*  */
  .kgk-connect-strava-btn {
    margin-left:auto;
    margin-right:auto;
  }
  .kgk-strava-auto-disconnect-notice {
    background-color: #fff3cd;
    border: 1px solid #ffe69c;
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 12px;
    text-align: left;
  }
  .kgk-strava-auto-disconnect-notice p {
    margin: 0 0 8px 0;
  }
  </style>